<div style="width: 100% !important;">
  <div class="modal-header">
    <h4 class="modal-title pull-left">PROBLEM SOLVING</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row p-10">

      <!-- <div class="col-sm-3" style="width: 20%;">
        <ng-multiselect-dropdown [placeholder]="'Select Year'" [data]="dropdownList" [(ngModel)]="filter1"
          [settings]="dropdownSettings" (onSelect)="datatableFilterAction()" (onDeSelect)="datatableFilterAction()"
          (onSelectAll)="onSelectAll($event)">
        </ng-multiselect-dropdown>
      </div>

      <div class="col-sm-3" style="width: 20%;">
        <ng-multiselect-dropdown [placeholder]="'Select Status'" [data]="dropdownList1" [(ngModel)]="filter2"
          [settings]="dropdownSettings1" (onSelect)="datatableFilterAction($event)"
          (onDeSelect)="datatableFilterAction()" (onSelectAll)="onSelectAll($event)">
        </ng-multiselect-dropdown>
      </div>

      <div class="col-sm-3" style="width: 20%;">
        <ng-multiselect-dropdown [placeholder]="'Please Select'" [data]="dropdownList2" [(ngModel)]="filter3"
          [settings]="dropdownSettings2" (onSelect)="datatableFilterAction($event)"
          (onDeSelect)="datatableFilterAction()" (onSelectAll)="onSelectAll($event)">
        </ng-multiselect-dropdown>
      </div> -->


      <!--   <div class="col-sm-3" style="width: 20%;">
                        <ng-multiselect-dropdown [placeholder]="'Select Status'" [data]="dropdownList3"
                          [(ngModel)]="filter4" [settings]="dropdownSettings3"
                          (onSelect)="datatableFilterAction($event)" (onDeSelect)="datatableFilterAction()"
                          (onSelectAll)="onSelectAll($event)">
                        </ng-multiselect-dropdown>
                      </div> -->
    </div>

    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
      <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover" id="table1"
        *ngIf="problem">
        <thead>
          <tr>
            <th>Hidden.No</th>
            <th>
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox"><i></i>
              </label>
            </th>
            <th>No.</th>
            <th>{{ lang.code }}</th>
            <th>{{ lang.type }}</th>
            <th>{{ lang.class }}</th>
            <th>{{ lang.input }}</th>
            <th>{{ lang.itemno }}</th>
            <th>{{ lang.jobno }}</th>
            <th>{{ lang.other }}</th>
            <th>{{ lang.descriptionoftheproblem }}</th>
            <th>{{ lang.openingDate }}</th>
            <th>{{ lang.status }}</th>
            <th>{{ lang.closingDate }}</th>
            <th>{{ lang.closingTime }}</th>
            <th>{{ lang.cost }}</th>
            <!-- <th>{{ lang.action }}</th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let record of problem let i = index" id="{{record.id}}">
            <td>{{i+1}}</td>
            <td></td>
            <td>{{i+1}}</td>
            <td><a [routerLink]="['/'+AppFrontRoutes.VIEW_PROBLEM_DETAILS+'/'+record.id]"
                class="blue_action">{{record.code }}</a></td>
            <td>{{record.ctype}}</td>
            <td>{{record.classes }}</td>
            <td>{{record.input }}</td>
            <td>{{record.item_no }}</td>
            <td>{{record.job_no }}</td>
            <td>{{record.other }}</td>
            <td>{{record.desp }}</td>
            <td>{{record.start_date}}</td>
            <td class="multi_lines_text">
              <div [innerHTML]="record.status"></div>
            </td>
            <td>{{record.cdate}}</td>
            <td>{{record.ctime}}</td>
            <td>{{record.cost}}</td>
            <!-- <td>
              <div class="btn-group dropup">

                <button type="button" class="btn btn-info dropdown-toggle circle_btn" data-toggle="dropdown"
                  aria-expanded="false"><i class="fa fa-tasks"></i></button>

                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="blue_action"
                      (click)="delete(record.id)"><i class="fa fa-trash"></i> {{ lang.delete }}</a></li>
                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="edit_action"
                      (click)="editProblemsolving(record.id)"><i class="fa fa-edit"></i> {{ lang.edit }}</a></li>
                  <li><a [routerLink]="['/'+AppFrontRoutes.SERVICING_VIEW+'/'+record.id]" class="blue_action"><i
                        class="glyphicon glyphicon-eye-open"></i> {{lang.view }}</a>
                  </li>
                </ul>
              </div>
            </td> -->

          </tr>
        </tbody>

      </table>
    </div>

  </div>
</div>
